module.exports = __webpack_public_path__ + "static/media/img_Benchmarking305.8ff0a5f8.png";